import React from "react";

interface GoalsFilterSubPanelProps {
  options: { id: string; label: string }[];
  selected: string[];
  onToggle: (id: string) => void;
  onClear: () => void;
}

export const GoalsFilterSubPanel: React.FC<GoalsFilterSubPanelProps> = ({ options, selected, onToggle, onClear }) => {
  return (
    <div className="absolute left-full top-0 z-50 ml-1 min-w-[200px] w-full rounded-lg border border-limestone-100 bg-white p-4 shadow-[0px_6px_12px_0px_rgba(0,0,0,0.12)]">
      <div className="flex flex-col gap-2">
        {options.map((option) => (
          <label key={option.id} className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={selected.includes(option.id)}
              onChange={() => onToggle(option.id)}
              className="h-4 w-4 rounded-xs border-limestone-100 text-green-600 focus:ring-green-500"
            />
            <span className="text-sm font-normal leading-[22px] text-limestone-900">{option.label}</span>
          </label>
        ))}
      </div>
      {selected.length > 0 && (
        <div className="mt-2 flex flex-col gap-2">
          <div className="h-px w-full bg-limestone-200" />
          <button
            className="text-left text-sm font-semibold leading-[22px] text-green-700 hover:text-green-800"
            onClick={onClear}
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};
